import { usePageConfigUser } from 'hooks/usePageConfig'
import {
  hasManagementDashboardPermission,
  hasLiveReportPermission,
  hasExportPdfPermission
} from 'utils/permissionUtil'
import { useIsDashboardOwner, useIsSharedWithAnalyst } from 'pages/dashboard/hooks'

const useActionPermissions = () => {
  const user = usePageConfigUser()
  const isDashboardOwner = useIsDashboardOwner()
  const isDashboardSharedWithAnalyst = useIsSharedWithAnalyst()

  const hasManagementPermission = hasManagementDashboardPermission(user?.userPermissions)
  const reportPermission = isDashboardOwner && hasManagementPermission
  const liveReportPermission = reportPermission && hasLiveReportPermission(user?.userPermissions)
  const copyPermission = hasManagementPermission
  const deletePermission = isDashboardOwner && hasManagementPermission
  const editPermission =
    (isDashboardOwner || isDashboardSharedWithAnalyst) && hasManagementPermission
  const createPermission = hasManagementPermission
  const pdfExportPermission = hasExportPdfPermission(user?.userPermissions)

  return {
    reportPermission,
    liveReportPermission,
    copyPermission,
    deletePermission,
    editPermission,
    createPermission,
    pdfExportPermission
  }
}

export default useActionPermissions
